import {CROP_GUIDE_COLOR, CROP_GUIDE_DASH_LENGTH_PX, CROP_GUIDE_LINE_WIDTH_PX} from '@PosterWhiteboard/poster/poster-media-crop/poster-media-crop.types';
import type {CropWindowSize} from '@PosterWhiteboard/poster/poster-media-crop/poster-media-crop.types';

/**
 * Paints the rule-of-thirds guides inside the crop window - the dashed thirds the modal cropper drew
 * via cropperjs' `guides` option. Runs in the window rectangle's local render space, whose origin is
 * its centre and whose units are scene pixels; the canvas zoom converts the screen-pixel line and dash
 * sizes into those units, so the guides stay a crisp hairline at any zoom.
 */
export const renderCropThirdsGuides = (window: CropWindowSize, zoom: number, ctx: CanvasRenderingContext2D): void => {
  const halfWidth = window.width / 2;
  const halfHeight = window.height / 2;
  const thirdWidth = window.width / 3;
  const thirdHeight = window.height / 3;
  const dashLength = CROP_GUIDE_DASH_LENGTH_PX / zoom;

  ctx.save();
  ctx.strokeStyle = CROP_GUIDE_COLOR;
  ctx.lineWidth = CROP_GUIDE_LINE_WIDTH_PX / zoom;
  ctx.setLineDash([dashLength, dashLength]);

  ctx.beginPath();
  for (const offsetFromLeft of [thirdWidth, thirdWidth * 2]) {
    ctx.moveTo(-halfWidth + offsetFromLeft, -halfHeight);
    ctx.lineTo(-halfWidth + offsetFromLeft, halfHeight);
  }
  for (const offsetFromTop of [thirdHeight, thirdHeight * 2]) {
    ctx.moveTo(-halfWidth, -halfHeight + offsetFromTop);
    ctx.lineTo(halfWidth, -halfHeight + offsetFromTop);
  }
  ctx.stroke();

  ctx.restore();
};
